import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import RobotoBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-Bold.ttf';
import RobotoExtraBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-ExtraBold.ttf';
import RobotoExtraBoldLight from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-ExtraLight.ttf';
import RobotoRegular from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-Regular.ttf';
import RobotoSemiBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-SemiBold.ttf';
import Logo from '../../images/sf_logo.png';

Font.register({ family: 'roboto', fonts: [
    { src: RobotoRegular}, // font-style: normal, font-weight: normal
    { src: RobotoExtraBold, fontWeight:'bold'}, // font-style: normal, font-weight: normal
    { src: RobotoExtraBoldLight, fontWeight:800}, // font-style: normal, font-weight: normal
    { src: RobotoBold, fontWeight:900}, // font-style: normal, font-weight: normal
    { src: RobotoSemiBold, fontWeight:600}, // font-style: normal, font-weight: normal
]});


// Create styles
const styles = StyleSheet.create({
    page: {
      backgroundColor: '#ffff',
      padding:'20px'
      
    },
    logoSection: {
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        alignItems:'center',
        height:'30px',
        paddingBottom:'20px',
        borderBottom:'1px solid #857e7e',
    },
    logo:{
        width:'auto',
        height:'22px',
    },
    addressSection:{
        display:'flex',
        flexDirection:'column',
        justifyContent:'flex-end',
        textAlign:'right',
    },
    addressLine:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-end',
        fontSize:8,
        textAlign:'right',

    },
    addressRow:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-end',
        alignItems:'center',
    },
    headerText:{
        fontSize:'15px',
        marginLeft:'10px',
    },
    section:{
        display:'flex',
        flexDirection:'row',
        fontSize:15,
        fontWeight:600,
        alignItems:'center',
    },
    topic:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        marginTop:'15px',
    },
    topicText:{
        fontFamily:'roboto',
        fontWeight:'600',
        fontSize:'12px',
        color:'#476b6b',
    },

    borderBox:{
        // border:'1px solid #e3d8d8',
        padding:'20px',
        minHeight:'200px',
        marginLeft:'40px',
        marginRight:'40px',
    },
    contentContainer:{
        display:'flex',
        flexDirection:'row',
        padding:'5px',
    },
    contentMainText:{
        fontSize:10,
        fontFamily:'roboto',
        // fontWeight:600,
        width:'30%',
        color:'#476b6b',
    },
    separator:{
        textAlign:'center',
        fontSize:10,
        fontFamily:'roboto',
        fontWeight:600,
        width:'10%',
    },
    contentSubText:{
        fontSize:10,
        fontFamily:'roboto',
        // fontWeight:'800',
        width:'60%',
        color:'#476b6b',
    },
    generatedSection:{
        marginTop:'5px',
        borderBottom:'1px solid #857e7e',
        width:'100%',
        paddingBottom:'5px',
    },
    generatedText:{
        fontSize:'8px',
        color:'#476b6bd9',
        paddingLeft:'20px'
    },
    mr10:{
        marginRight:10,
    },
    miniImage:{
        width:8,
        height:8,
        marginRight:3,
    },
    dots:{
        fontSize:8,
        marginRight:6,
        width:10,
        textAlign:'center',
    },

    addressLineBottom: {
        width:'100%',
        paddingTop:'5px',
    },
    addressLineBottomText:{
        fontSize:'10px',
        paddingLeft:'20px',
        paddingRight:'20px',
        color:'#476b6bd9',
    },
});
  
// Create Document Component
const LetterHead = ({children}) => (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View style={styles.logoSection}>
          <Image style={styles.logo} src={Logo} />
        </View>
        <View style={styles.topic}>
         <Text style={styles.topicText}>TRANSACTION NOTE</Text>
        </View>
        <View style={styles.borderBox}>
            {children}
        </View>
        <View style={styles.generatedSection}>
            <Text style={styles.generatedText}>
                * This is a computer generated document and does not require a signature.
            </Text>
        </View>
        <View style={styles.addressLineBottom}>
            <Text style={styles.addressLineBottomText}>
            2nd Floor, 267, Galle Road, Colombo 03. Telephone : (011) 2301301 Fax : (011) 2375780 email : deposit@senfin.com
            </Text>
            <Text style={styles.addressLineBottomText}>
            web : www.senfin.com {new Date().getFullYear()} Senkadagala Finance, All rights reserved
            </Text>
        </View>
      </Page>
    </Document>
 );

 export default LetterHead;